import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, border } from 'polished';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { DsiCheckBox as CheckBox } from '../General/Checkbox';
import { getDeliveryAddressInfo } from '../../../utilities/selectors';

interface Props {
  address?: any;
  active?: boolean;
  onClick: (id) => void;
  smallBoxes?: boolean;
}

function CartAddressBlock({
  onClick,
  address,
  active = false,
  smallBoxes,
}: Props) {
  const {
    deliveryStreet,
    deliveryNumber,
    deliveryZip,
    deliveryCity,
    country,
    id,
    isDefault,
    name,
    surname,
    phone,
  } = getDeliveryAddressInfo(address);
  return (
    // tslint:disable-next-line:jsx-no-lambda
    <Wrapper active={active} onClick={() => onClick(1)}>
      <Street>{`${name} ${name === surname ? '' : surname}`}</Street>
      <Street>{`${deliveryStreet}`}</Street>
      <Text>{`${deliveryCity} ${deliveryZip}, ${country}`}</Text>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)<{ active: boolean }>`
  padding: ${rem(16)};
  border: ${({ theme, active }) =>
    active ? theme.borders.active : theme.borders.secondary};
  /* outline: ${({ theme, active }) =>
    active ? `none` : `${rem(1)} solid transparent`}; */
  box-shadow: ${({ theme }) => theme.boxShadow.input};
  border-radius: ${rem(4)};
  max-width: ${rem(328)};
  width: 100%;
  /* margin-bottom: ${rem(32)};
  margin-right: ${rem(32)}; */
  transition: border 0.2s ease;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.white};
  min-height: ${rem(94)};

  ${({ theme }) => theme.mediab.m580`
    margin-right: 0;
  `}
`;

const Text = styled(TextP)`
  font-weight: 400;
`;

const Street = styled(TextP)`
  font-weight: 500;
`;

const CityCountryWrapper = styled(FlexCol)`
  margin: ${rem(16)} 0 ${rem(24)};
`;

const ContactWrapper = styled(FlexCol)``;

export { CartAddressBlock as DsiCartAddressBlock };
